import { ref } from 'vue'
import type { RouteLocationNormalized } from 'vue-router'

const previousRoute = ref<RouteLocationNormalized | null>(null)

export function usePreviousRoute() {
  return {
    previousRoute,
    setPreviousRoute(route: RouteLocationNormalized) {
      previousRoute.value = route
    }
  }
}